import React from 'react';
import { connect } from 'react-redux';
import AppUpdateLandingPres from './../presentational/AppUpdateLandingPres';
import AppUpdateTabPres from './../presentational/AppUpdateTabPres';
import { resetAppUpdate } from './../state/appUpdateActions';
class AppUpdateLandingContainer extends React.Component {
  state = {
    activeTabType: this.props.isIos ? 'ios' : 'android',
    activeTabTypeId: this.props.isIos ? 1 : 0,
  };

  tabTypes = {
    0: 'android',
    1: 'ios',
  };

  handleChangeTabType = val => {
    resetAppUpdate();
    const value = val || 0;
    this.setState({
      activeTabType: this.tabTypes[value],
      activeTabTypeId: parseInt(value, 10),
    });
  };

  render() {
    return (
      <AppUpdateTabPres {...this.props} activeTab={this.state.activeTabTypeId} handleChangeTabType={this.handleChangeTabType}>
        <AppUpdateLandingPres {...this.props} activeTab={this.state.activeTabTypeId} {...this.state} />
      </AppUpdateTabPres>
    );
  }
}

const mapStateToProps = state => ({});

const mapDispatchToProps = {
  resetAppUpdate,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AppUpdateLandingContainer);



// WEBPACK FOOTER //
// ./src/ui/features/AppUpdate/containers/AppUpdateLandingContainer.js